module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/quote-automation-tour-3.gif"